(function () {
  'use strict';

  var VIDEO_URL = 'https://cdn.shopify.com/videos/c/vp/8f07b15786ca44b891faf5582dfc0e17/8f07b15786ca44b891faf5582dfc0e17.HD-720p-1.6Mbps-93658525.mp4';
  var TARGET_SELECTOR = '.image-block--image_ggYHf4';
  var READY_ATTRIBUTE = 'data-luem-drawing-ready';

  function setupDrawing(target) {
    if (!target || target.hasAttribute(READY_ATTRIBUTE)) return;
    target.setAttribute(READY_ATTRIBUTE, 'true');

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    target.classList.add('luem-live-drawing');

    var video = document.createElement('video');
    video.className = 'luem-drawing-video';
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.autoplay = false;
    video.preload = 'auto';
    video.disablePictureInPicture = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.setAttribute('aria-hidden', 'true');
    video.setAttribute('tabindex', '-1');
    video.src = VIDEO_URL;
    target.appendChild(video);
    video.load();

    var state = 'idle';
    var retryUsed = false;
    var observer;

    function revealOriginal() {
      if (state === 'complete') return;
      state = 'complete';
      target.classList.remove('is-playing');
      target.classList.add('is-complete');
      video.pause();
      if (observer) observer.disconnect();
    }

    function requestPlayback() {
      var playback;

      try {
        playback = video.play();
      } catch (error) {
        revealOriginal();
        return;
      }

      if (playback && typeof playback.catch === 'function') {
        playback.catch(function () {
          if (retryUsed || state === 'complete') {
            revealOriginal();
            return;
          }

          retryUsed = true;
          video.addEventListener('canplay', function () {
            if (state === 'complete') return;
            var retry = video.play();
            if (retry && typeof retry.catch === 'function') {
              retry.catch(revealOriginal);
            }
          }, { once: true });
        });
      }
    }

    function startOnce() {
      if (state !== 'idle') return;
      state = 'starting';
      if (observer) observer.disconnect();

      try {
        video.currentTime = 0;
      } catch (error) {
        // Safari can reject currentTime before metadata is available; playback still starts at zero.
      }

      requestPlayback();
    }

    video.addEventListener('playing', function () {
      if (state === 'complete') return;
      state = 'playing';
      target.classList.add('is-playing');
    }, { once: true });

    video.addEventListener('ended', revealOriginal, { once: true });
    video.addEventListener('error', revealOriginal, { once: true });

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i += 1) {
          if (entries[i].isIntersecting && entries[i].intersectionRatio >= 0.28) {
            startOnce();
            break;
          }
        }
      }, {
        threshold: [0.28, 0.45],
        rootMargin: '0px 0px -8% 0px'
      });
      observer.observe(target);
    } else {
      startOnce();
    }
  }

  function init(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var targets = root.querySelectorAll(TARGET_SELECTOR);

    for (var i = 0; i < targets.length; i += 1) {
      setupDrawing(targets[i]);
    }

    if (root.matches && root.matches(TARGET_SELECTOR)) {
      setupDrawing(root);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
}());
